// extracted by mini-css-extract-plugin
export default {"videoList":"YoutubeContainer_videoList__pk09b","YoutubeContainer":"YoutubeContainer_YoutubeContainer__fHrSk","iframe":"YoutubeContainer_iframe__FqB8I"};